import React from 'react';
import { Grid, Popup, Table } from 'semantic-ui-react';
import { get, isNull, isUndefined } from 'lodash';
import { convertEpochToDate } from '../../../../../../../util/constants';

const MonthlyTable = ({ cbpDailyData, formatMoney, countryName }) => {
  return (
    <>
      {countryName === 'canada' ||
        (countryName === 'CANADA' && (
          <>
            <Table basic='very' selectable>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>IMPORTER</Table.HeaderCell>
                  <Table.HeaderCell>TRANSACTION#</Table.HeaderCell>
                  <Table.HeaderCell textAlign='right'>CCN#</Table.HeaderCell>
                  <Table.HeaderCell textAlign='right'>
                    PURCHASE ORDER
                  </Table.HeaderCell>
                  <Table.HeaderCell>DOC TYPE</Table.HeaderCell>
                  <Table.HeaderCell>PORT</Table.HeaderCell>
                  <Table.HeaderCell>DUTY</Table.HeaderCell>
                  <Table.HeaderCell>SIMA/EXCISE</Table.HeaderCell>
                  <Table.HeaderCell>GST</Table.HeaderCell>
                  <Table.HeaderCell>PENALTY/INTEREST</Table.HeaderCell>
                </Table.Row>
              </Table.Header>

              <Table.Body>
                {cbpDailyData?.statementEntries
                  ? cbpDailyData.statementEntries?.map((item, i) => (
                      <Table.Row style={{ cursor: 'pointer' }}>
                        <Table.Cell>{item.dailyStatementNumber}</Table.Cell>
                        <Popup
                          size='tiny'
                          trigger={
                            <Table.Cell>
                              $
                              {formatMoney(
                                (
                                  parseFloat(
                                    cbpDailyData.statementEntries[i]
                                      .totalAmountDue
                                  ) / 100
                                ).toFixed(2)
                              )}
                            </Table.Cell>
                          }
                          header='OTHER FEES'
                          on={['hover', 'click']}
                        >
                          <center>
                            <p className='feePopupHeader'>OTHER FEES</p>
                          </center>
                          <br />
                          <Grid columns={2}>
                            {item.fees &&
                              item?.fees?.map((fee, i) => (
                                <Grid.Row>
                                  <Grid.Column style={{ width: '70%' }}>
                                    <p className='cbpOtherFeeLabel'>
                                      {fee.key}
                                    </p>
                                  </Grid.Column>
                                  <Grid.Column style={{ width: '20%' }}>
                                    <p className='cbpOtherFeeValue'>
                                      $
                                      {formatMoney(
                                        parseFloat(fee.value / 100).toFixed(2)
                                      )}
                                    </p>
                                  </Grid.Column>
                                </Grid.Row>
                              ))}
                          </Grid>
                        </Popup>
                        <Table.Cell textAlign='right'>
                          {convertEpochToDate(
                            get(item, 'authorizationStatus.dateAccepted', ''),
                            true,
                            false
                          )}
                        </Table.Cell>
                        <Table.Cell textAlign='right'>
                          {cbpDailyData?.processingPort}
                        </Table.Cell>
                      </Table.Row>
                    ))
                  : null}
                <Table.Row className='lastRow'>
                  <Table.Cell colSpan='2'>
                    <button>TOTAL (ON 10/28/2020)</button>
                  </Table.Cell>
                  <Table.Cell></Table.Cell>
                  <Table.Cell></Table.Cell>
                  <Table.Cell></Table.Cell>
                  <Table.Cell></Table.Cell>
                  <Table.Cell>C$ 8,000.00</Table.Cell>
                  <Table.Cell>C$ 9,000.00</Table.Cell>
                  <Table.Cell>C$ 9,000.00</Table.Cell>
                  <Table.Cell>C$ 9,000.00</Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
            <br />
            <br />
            <br />
            <div className='cbpPaymentButtonRow'>
              <div className='buttonRowTextDiv'>
                <p className='buttonRowText buttonRowLabel'>TOTAL</p>
                <p className='buttonRowText buttonRowTotal'>
                  $
                  {formatMoney(
                    (parseFloat(cbpDailyData?.totalAmountDue) / 100).toFixed(2)
                  )}
                </p>
              </div>
            </div>
          </>
        ))}

      {countryName === 'US' ||
        (countryName === 'UNITED_STATES' && (
          <>
            <Table basic='very' selectable>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>DAILY STATEMENT #</Table.HeaderCell>
                  <Table.HeaderCell>TOTAL DUE</Table.HeaderCell>
                  <Table.HeaderCell textAlign='right'>
                    AUTHORIZED ON
                  </Table.HeaderCell>
                  <Table.HeaderCell textAlign='right'>
                    PORT OF ENTRY
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Header>

              <Table.Body>
                {cbpDailyData?.statementEntries
                  ? cbpDailyData.statementEntries?.map((item, i) => (
                      <Table.Row style={{ cursor: 'pointer' }}>
                        <Table.Cell>{item?.dailyStatementNumber}</Table.Cell>
                        <Popup
                          size='tiny'
                          trigger={
                            <Table.Cell>
                              {!isNull(cbpDailyData?.statementEntries[i]) &&
                              !isUndefined(cbpDailyData?.statementEntries[i])
                                ? `$ ${formatMoney(
                                    (
                                      parseFloat(
                                        cbpDailyData?.statementEntries[i]
                                          .totalAmountDue
                                      ) / 100
                                    ).toFixed(2)
                                  )}`
                                : '$0.00'}
                            </Table.Cell>
                          }
                          header='OTHER FEES'
                          on={['hover', 'click']}
                        >
                          <center>
                            <p className='feePopupHeader'>OTHER FEES</p>
                          </center>
                          <br />
                          <Grid columns={2}>
                            {item.fees &&
                              item.fees.map((fee, i) => (
                                <Grid.Row>
                                  <Grid.Column style={{ width: '70%' }}>
                                    <p className='cbpOtherFeeLabel'>
                                      {fee.key}
                                    </p>
                                  </Grid.Column>
                                  <Grid.Column style={{ width: '20%' }}>
                                    <p className='cbpOtherFeeValue'>
                                      $
                                      {formatMoney(
                                        parseFloat(fee.value / 100).toFixed(2)
                                      )}
                                    </p>
                                  </Grid.Column>
                                </Grid.Row>
                              ))}
                          </Grid>
                        </Popup>
                        <Table.Cell textAlign='right'>
                          {convertEpochToDate(
                            get(item, 'authorizationStatus.dateAccepted', ''),
                            true,
                            false
                          )}
                        </Table.Cell>
                        <Table.Cell textAlign='right'>
                          {cbpDailyData?.processingPort}
                        </Table.Cell>
                      </Table.Row>
                    ))
                  : null}
              </Table.Body>
            </Table>
            <br />
            <br />
            <br />
            <div className='cbpPaymentButtonRow'>
              <div className='buttonRowTextDiv'>
                <p className='buttonRowText buttonRowLabel'>TOTAL</p>
                <p className='buttonRowText buttonRowTotal'>
                  $
                  {formatMoney(
                    (parseFloat(cbpDailyData.totalAmountDue) / 100).toFixed(2)
                  )}
                </p>
              </div>
            </div>
          </>
        ))}
    </>
  );
};

export default MonthlyTable;
